import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGenerateContent } from '../api/researchApi';

const TestResearchPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const generateContent = useGenerateContent();
  const [status, setStatus] = useState<string>('idle');
  const [result, setResult] = useState<any>(null);

  const handleStartResearch = async () => {
    if (!projectId) return;
    
    try {
      setStatus('starting');
      const response = await generateContent.mutateAsync({ 
        project_id: parseInt(projectId),
        report_types: ['overview', 'demographics', 'competitor', 'reviews', 'discovery', 'keywords']
      });
      
      setResult(response);
      setStatus('completed');
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">🧪 Research Test Page</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Project Information</h2>
          <p><strong>Project ID:</strong> {projectId || 'Not provided'}</p>
          <p><strong>Status:</strong> {status}</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Research Controls</h2>
          <button
            onClick={handleStartResearch}
            disabled={generateContent.isPending || status === 'starting'}
            className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
          >
            {generateContent.isPending ? 'Starting Research...' : 'Start Research'}
          </button>
        </div>

        {result && (
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4">Research Result</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-auto">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}

        {status === 'error' && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h3 className="text-red-800 font-semibold">Error</h3>
            <p className="text-red-600">Research generation failed. Check the console for details.</p>
          </div>
        )}

        {status === 'completed' && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h3 className="text-green-800 font-semibold">Success!</h3>
            <p className="text-green-600">Research generation started successfully. Check the result above.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestResearchPage;
